import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectConfigValue } from '../../selectors/config';
import { selectLocationIds } from '../../selectors/offer';
import { Device } from '../common/Device';
import { HAS_BEEN_CLOSED_MARK } from './constants';
import { MLSNPublicationBannerDesktop, MLSNPublicationBannerMobile } from './components';

export const MLSNPublicationBannerContainer = () => {
  const locations = useSelector(selectLocationIds);
  const mlsnPublicationBannerLocations = useSelector(selectConfigValue('mlsnPublicationBannerLocations'));

  const isRequiredLocation = mlsnPublicationBannerLocations.some(location => locations.includes(location));

  const [isClosed, setIsClosed] = React.useState(() => {
    const isClosed = typeof sessionStorage === 'undefined' ? false : !!sessionStorage.getItem(HAS_BEEN_CLOSED_MARK);

    return isClosed;
  });

  const isVisible = isRequiredLocation && !isClosed;

  const handleCloseClick = React.useCallback(() => {
    sessionStorage.setItem(HAS_BEEN_CLOSED_MARK, '1');
    setIsClosed(true);
  }, [isClosed]);

  if (!isVisible) {
    return null;
  }

  return (
    <Device
      desktop={<MLSNPublicationBannerDesktop handleCloseClick={handleCloseClick} />}
      mobile={<MLSNPublicationBannerMobile handleCloseClick={handleCloseClick} />}
    />
  );
};
